__webpack_require__.p = "https://uat.auth.byonde.asia/";